document.addEventListener('DOMContentLoaded', function () {
  // Reuse the existing blocks on desktop, leaving their mobile DOM order intact.
  function initPdpDesktopLayout(scope) {
    scope.querySelectorAll('[data-section-type="main-product"].pdp-figma').forEach(function (product) {
      if (product.pdpDesktopCleanup) return;
      var form = product.querySelector('.product-form');
      if (!form) return;
      var desktop = window.matchMedia('(min-width: 768px)');
      var thumbnails = product.querySelector('.gallery .thumbnails');
      function labelThumbnails() {
        if (!thumbnails || !desktop.matches) return;
        thumbnails.querySelectorAll('.thumbnail').forEach(function (thumbnail, index) {
          thumbnail.setAttribute('aria-label', (document.documentElement.lang === 'en' ? 'Product media ' : 'Produktmedium ') + (index + 1));
        });
      }
      var thumbnailObserver = new MutationObserver(labelThumbnails);
      if (thumbnails) thumbnailObserver.observe(thumbnails, {childList: true});
      var blocks = Array.from(form.children).filter(function (node) { return node.matches('.pdp-block'); });
      var details = [];
      var features = [];
      var faq = [];
      var inFaq = false;
      blocks.forEach(function (block) {
        if (block.dataset.pdpBlock === 'pdp_faq_heading') inFaq = true;
        if (inFaq) faq.push(block);
        else if (block.dataset.pdpType === 'accordion') details.push(block);
        else if (/^(lab_results_slider|steps_block)$/.test(block.dataset.pdpType)) features.push(block);
      });
      var moved = [];
      var containers = [];
      function restore() {
        moved.forEach(function (entry) {
          entry.marker.replaceWith(entry.block);
        });
        containers.forEach(function (container) { container.remove(); });
        moved = [];
        containers = [];
      }
      function place(group, className, parent, before) {
        if (!group.length) return;
        var container = document.createElement('div');
        container.className = 'pdp-figma ' + className;
        group.forEach(function (block) {
          var marker = document.createComment('pdp-mobile-position');
          block.before(marker);
          moved.push({block: block, marker: marker});
          container.appendChild(block);
        });
        parent.insertBefore(container, before || null);
        containers.push(container);
      }
      function updateLayout() {
        restore();
        if (!desktop.matches) return;
        labelThumbnails();
        place(details, 'pdp-desktop-details', product);
        place(features, 'pdp-desktop-features', product);
        var guarantee = document.querySelector('.pdp-story--guarantee');
        var section = guarantee && guarantee.closest('.shopify-section');
        place(faq, 'pdp-desktop-faq', section ? section.parentNode : product, section);
      }
      desktop.addEventListener('change', updateLayout);
      product.pdpDesktopCleanup = function () {
        desktop.removeEventListener('change', updateLayout);
        thumbnailObserver.disconnect();
        restore();
      };
      updateLayout();
    });
  }

  function initPdpDesktopVideos(scope) {
    if (!document.body.classList.contains('template-suffix-variation-pdp-new')) return;
    scope.querySelectorAll('.ho3-video-wrapper').forEach(function (wrapper) {
      if (wrapper.pdpDesktopCleanup) return;
      var desktop = window.matchMedia('(min-width: 768px)');
      var videos = Array.from(wrapper.querySelectorAll('video'));
      var controls = videos.map(function (video) { return video.controls; });
      function updateVideos() {
        videos.forEach(function (video, index) {
          video.pause();
          video.controls = desktop.matches || controls[index];
        });
        wrapper.classList.remove('is-playing');
      }
      // The mobile carousel toggles its active video when the wrapper is clicked.
      // Desktop exposes every video with its own native playback controls.
      function onClick(event) {
        if (desktop.matches) event.stopImmediatePropagation();
      }
      function onPlay(event) {
        if (!desktop.matches) return;
        videos.forEach(function (video) { if (video !== event.target) video.pause(); });
      }
      wrapper.addEventListener('click', onClick, true);
      wrapper.addEventListener('play', onPlay, true);
      desktop.addEventListener('change', updateVideos);
      wrapper.pdpDesktopCleanup = function () {
        wrapper.removeEventListener('click', onClick, true);
        wrapper.removeEventListener('play', onPlay, true);
        desktop.removeEventListener('change', updateVideos);
        videos.forEach(function (video, index) { video.controls = controls[index]; });
      };
      if (desktop.matches) updateVideos();
    });
  }

  function initPdpPresentation(scope) {
    scope.querySelectorAll('.pdp-figma .product-form').forEach(function (form) {
      if (form.dataset.pdpPresentationReady) return;
      form.dataset.pdpPresentationReady = 'true';
      form.querySelectorAll('.option-selector').forEach(function (selector) {
        var label = selector.querySelector('.label');
        var colorOptions = false;
        selector.querySelectorAll('.opt-btn').forEach(function (input) {
          var value = input.value.toLowerCase();
          var color = /weiß|weiss|white/.test(value) ? 'white' : /schwarz|black/.test(value) ? 'black' : '';
          var swatch = input.nextElementSibling;
          if (color && swatch) {
            colorOptions = true;
            swatch.dataset.pdpColor = color;
            swatch.title = input.value;
          }
        });
        if (!colorOptions || !label) return;
        var valueLabel = label.querySelector('.label__value');
        if (!valueLabel) {
          valueLabel = document.createElement('span');
          valueLabel.className = 'label__value';
          label.appendChild(valueLabel);
        }
        function updateColor() {
          var input = selector.querySelector('.opt-btn:checked');
          valueLabel.textContent = input ? input.value : '';
        }
        selector.addEventListener('change', updateColor);
        updateColor();
      });
      var button = form.querySelector('button[data-add-to-cart-text]');
      if (!button) return;
      function updateButtonPrice() {
        var price = form.querySelector('.price-area .current-price');
        var text = price ? price.textContent.trim().replace(/EUR/g, '€') : '';
        if (!button.disabled && text) button.dataset.pdpPrice = text;
        else button.removeAttribute('data-pdp-price');
      }
      // Theme code replaces the price fragment and button state on variant changes.
      var priceContainer = form.querySelector('.price-container');
      var observer = new MutationObserver(updateButtonPrice);
      if (priceContainer) observer.observe(priceContainer, {childList: true, subtree: true, characterData: true});
      observer.observe(button, {attributes: true, attributeFilter: ['disabled']});
      updateButtonPrice();
      form.pdpPresentationCleanup = function () { observer.disconnect(); };
    });
    scope.querySelectorAll('[data-pdp-review-carousel]').forEach(function (carousel) {
      if (carousel.dataset.pdpReady) return;
      carousel.dataset.pdpReady = 'true';
      var track = carousel.querySelector('.rw-peek__track');
      var cards = Array.from(carousel.querySelectorAll('.rw-review-card'));
      var previous = carousel.querySelector('[data-pdp-previous]');
      var next = carousel.querySelector('[data-pdp-next]');
      var counter = carousel.querySelector('[data-pdp-counter]');
      if (!track || !cards.length || !previous || !next) return;
      var index = 0;
      function update() {
        var left = track.getBoundingClientRect().left;
        var distance = Infinity;
        cards.forEach(function (card, i) {
          var d = Math.abs(card.getBoundingClientRect().left - left);
          if (d < distance) { distance = d; index = i; }
        });
        counter.textContent = (index + 1) + ' / ' + cards.length;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      function move(direction) {
        var target = cards[Math.max(0, Math.min(cards.length - 1, index + direction))];
        track.scrollBy({left: target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, {passive: true});
      var resize = new ResizeObserver(update);
      resize.observe(track);
      carousel.pdpPresentationCleanup = function () { resize.disconnect(); };
      update();
    });
  }

  function initPdpCertificationSlides(scope) {
    scope.querySelectorAll('[data-pdp-certification-carousel]').forEach(function (carousel) {
      if (carousel.pdpCertificationCleanup) return;
      var track = carousel.querySelector('.pdp-certification-track');
      var slides = Array.from(carousel.querySelectorAll('[data-pdp-certification-slide]'));
      var controls = carousel.querySelector('.pdp-certification-controls');
      if (!track || slides.length < 2 || !controls) return;
      var previous = controls.querySelector('[data-pdp-certification-previous]');
      var next = controls.querySelector('[data-pdp-certification-next]');
      var counter = controls.querySelector('[data-pdp-certification-counter]');
      var index = 0;
      function update() {
        var left = track.getBoundingClientRect().left;
        var closest = Infinity;
        slides.forEach(function (slide, i) {
          var distance = Math.abs(slide.getBoundingClientRect().left - left);
          if (distance < closest) { closest = distance; index = i; }
        });
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
        var label = (index + 1) + ' / ' + slides.length;
        if (counter.textContent !== label) counter.textContent = label;
      }
      function moveTo(target, instant) {
        target = Math.max(0, Math.min(slides.length - 1, target));
        track.scrollBy({
          left: slides[target].getBoundingClientRect().left - track.getBoundingClientRect().left,
          behavior: instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      function onPrevious() { moveTo(index - 1); }
      function onNext() { moveTo(index + 1); }
      function onKey(event) {
        if (event.target !== track) return;
        var target;
        if (event.key === 'ArrowLeft') target = index - 1;
        else if (event.key === 'ArrowRight') target = index + 1;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = slides.length - 1;
        else return;
        event.preventDefault();
        moveTo(target);
      }
      function onBlockSelect(event) {
        var slide = event.target.closest('[data-pdp-certification-slide]');
        var selected = slides.indexOf(slide);
        if (selected !== -1) moveTo(selected, true);
      }
      previous.addEventListener('click', onPrevious);
      next.addEventListener('click', onNext);
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', onKey);
      document.addEventListener('shopify:block:select', onBlockSelect);
      var resize = new ResizeObserver(update);
      resize.observe(track);
      controls.hidden = false;
      update();
      carousel.pdpCertificationCleanup = function () {
        previous.removeEventListener('click', onPrevious);
        next.removeEventListener('click', onNext);
        track.removeEventListener('scroll', update);
        track.removeEventListener('keydown', onKey);
        document.removeEventListener('shopify:block:select', onBlockSelect);
        resize.disconnect();
        controls.hidden = true;
        delete carousel.pdpCertificationCleanup;
      };
    });
  }

  initPdpCertificationSlides(document);
  initPdpPresentation(document);
  initPdpDesktopLayout(document);
  initPdpDesktopVideos(document);
  document.addEventListener('shopify:section:load', function (event) {
    initPdpCertificationSlides(event.target);
    initPdpPresentation(event.target);
    initPdpDesktopLayout(event.target);
    initPdpDesktopVideos(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-pdp-certification-carousel]').forEach(function (node) {
      if (node.pdpCertificationCleanup) node.pdpCertificationCleanup();
    });
    event.target.querySelectorAll('[data-section-type="main-product"].pdp-figma, .ho3-video-wrapper').forEach(function (node) {
      if (node.pdpDesktopCleanup) node.pdpDesktopCleanup();
    });
    event.target.querySelectorAll('.product-form, [data-pdp-review-carousel]').forEach(function (node) {
      if (node.pdpPresentationCleanup) node.pdpPresentationCleanup();
    });
  });

  // --- Variant gallery: variant-specific images via metafields ---
  var $gallery = $('.gallery[data-cluster-variant-gallery]');

  if ($gallery.length) {
    var $slideshow = $gallery.find('.product-slideshow');
    var $thumbnails = $gallery.find('.thumbnails');
    var $slidesStore = $gallery.find('.cluster-variant-slides-store');
    var $thumbsStore = $gallery.find('.cluster-variant-thumbs-store');
    var currentVariantId = String($gallery.data('cluster-current-variant'));

    function activateLazyImages($container) {
      $container.find('img[data-src]').each(function () {
        this.src = this.dataset.src;

        if (this.dataset.srcset) {
          this.srcset = this.dataset.srcset;
        }

        this.classList.add('loaded');
      });
    }

    function switchVariantGallery(variantId) {
      variantId = String(variantId);

      if (!variantId || variantId === currentVariantId) return;

      var $newSlides = $slidesStore.find('[data-cluster-variant-id="' + variantId + '"]');
      if (!$newSlides.length) return;

      currentVariantId = variantId;

      $slideshow.find('video').each(function () {
        this.pause();
      });

      var previousSlickSettings = null;

      if ($slideshow.hasClass('slick-initialized')) {
        previousSlickSettings = $.extend(true, {}, $slideshow.slick('getSlick').originalSettings);
        $slideshow.slick('unslick');
      }

      $slideshow.html($newSlides.html());
      activateLazyImages($slideshow);
      // 20.10.2026: Bilder der neuen Farbe sofort laden. Vorher geschah das nur zufällig über den Seitenaufbau (Lazy-Loader),
      // seit das erste Galeriebild direkt mit Priorität kommt, nicht mehr. So bleibt das Wischen nach dem Farbwechsel wie bisher.
      $slideshow.find('img').each(function () { if (this.loading === 'lazy') this.loading = 'eager'; });

      var reinitSlickSettings = previousSlickSettings || {
        adaptiveHeight: true,
        initialSlide: 0
      };

      reinitSlickSettings.initialSlide = 0;
      $slideshow.slick(reinitSlickSettings);

      var $newThumbs = $thumbsStore.find('[data-cluster-variant-id="' + variantId + '"]');

      if ($newThumbs.length) {
        $thumbnails.html($newThumbs.html());
        activateLazyImages($thumbnails);
      }
    }

    $gallery.on('variantImageSelected', function (e, data) {
      e.stopImmediatePropagation();

      if (data && data.id) {
        switchVariantGallery(data.id);
      }
    });

    $(window).on('cc-variant-updated', function (e, args) {
      if (args && args.variant && args.variant.id) {
        if ($slidesStore.find('[data-cluster-variant-id="' + args.variant.id + '"]').length) {
          switchVariantGallery(args.variant.id);
        }
      }
    });
  }

  function initPdpUpsellToggle(toggle) {
    if (toggle.dataset.pdpUpsellInitialized === 'true') return;

    var block = toggle.closest('.pdp-upsell-block');
    var formContainer = toggle.closest('.product-form');
    var purchaseForm = formContainer ? formContainer.querySelector('form.product-purchase-form') : null;
    var priceMapElement = block ? block.querySelector('[data-pdp-upsell-price-map]') : null;

    if (!block || !formContainer || !purchaseForm || !priceMapElement) return;

    var priceMap;

    try {
      priceMap = JSON.parse(priceMapElement.textContent);
    } catch (error) {
      return;
    }

    toggle.dataset.pdpUpsellInitialized = 'true';

    var errorElement = block.querySelector('[data-pdp-upsell-error]');
    var upsellVariantId = toggle.dataset.upsellVariantId;

    function getCurrentVariantId() {
      var variantSelector = purchaseForm.querySelector('[name="id"]');
      return variantSelector ? String(variantSelector.value || '') : '';
    }

    function applyUpsellPrice() {
      var currentVariantId = getCurrentVariantId();
      var combinedPrice = priceMap[currentVariantId];
      var priceElement = formContainer.querySelector('.cluster-pdp-price-1');

      if (!priceElement) return;

      var currentPriceElement = priceElement.querySelector('.current-price');
      var comparePriceElement = priceElement.querySelector('.was-price');
      var discountElement = priceElement.querySelector('.cluster-discount-amount');
      var isActive = toggle.getAttribute('aria-pressed') === 'true';

      if (isActive && combinedPrice) {
        if (!comparePriceElement && combinedPrice.compare && currentPriceElement) {
          comparePriceElement = document.createElement('span');
          comparePriceElement.className = 'was-price theme-money';
          comparePriceElement.dataset.pdpUpsellCreated = 'true';
          priceElement.insertBefore(comparePriceElement, currentPriceElement);
        } else if (comparePriceElement && comparePriceElement.dataset.pdpUpsellCreated === 'true' && !combinedPrice.compare) {
          comparePriceElement.remove();
          comparePriceElement = null;
        }

        if (!discountElement && combinedPrice.discount) {
          discountElement = document.createElement('span');
          discountElement.className = 'cluster-discount-amount';
          discountElement.dataset.pdpUpsellCreated = 'true';
          priceElement.appendChild(discountElement);
        } else if (discountElement && discountElement.dataset.pdpUpsellCreated === 'true' && !combinedPrice.discount) {
          discountElement.remove();
          discountElement = null;
        }
      }

      var variantPriceChanged = priceElement.dataset.pdpUpsellBaseVariantId !== currentVariantId;

      if (currentPriceElement && (variantPriceChanged || !currentPriceElement.dataset.pdpUpsellBaseText)) {
        currentPriceElement.dataset.pdpUpsellBaseText = currentPriceElement.textContent;
      }

      if (
        comparePriceElement &&
        comparePriceElement.dataset.pdpUpsellCreated !== 'true' &&
        (variantPriceChanged || !comparePriceElement.dataset.pdpUpsellBaseText)
      ) {
        comparePriceElement.dataset.pdpUpsellBaseText = comparePriceElement.textContent;
      }

      if (
        discountElement &&
        discountElement.dataset.pdpUpsellCreated !== 'true' &&
        (variantPriceChanged || !discountElement.dataset.pdpUpsellBaseText)
      ) {
        discountElement.dataset.pdpUpsellBaseText = discountElement.textContent;
      }

      priceElement.dataset.pdpUpsellBaseVariantId = currentVariantId;

      if (isActive && combinedPrice) {
        if (currentPriceElement) {
          currentPriceElement.textContent = combinedPrice.current;
        }

        if (comparePriceElement && combinedPrice.compare) {
          comparePriceElement.textContent = combinedPrice.compare;
        }

        if (discountElement && combinedPrice.discount) {
          discountElement.textContent = combinedPrice.discount;
        }
      } else {
        if (currentPriceElement && currentPriceElement.dataset.pdpUpsellBaseText) {
          currentPriceElement.textContent = currentPriceElement.dataset.pdpUpsellBaseText;
        }

        if (comparePriceElement && comparePriceElement.dataset.pdpUpsellCreated === 'true') {
          comparePriceElement.remove();
        } else if (comparePriceElement && comparePriceElement.dataset.pdpUpsellBaseText) {
          comparePriceElement.textContent = comparePriceElement.dataset.pdpUpsellBaseText;
        }

        if (discountElement && discountElement.dataset.pdpUpsellCreated === 'true') {
          discountElement.remove();
        } else if (discountElement && discountElement.dataset.pdpUpsellBaseText) {
          discountElement.textContent = discountElement.dataset.pdpUpsellBaseText;
        }
      }
    }

    function setUpsellActive(isActive) {
      toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      applyUpsellPrice();
    }

    function showUpsellError(message) {
      if (!errorElement) return;

      errorElement.textContent = message;
      errorElement.hidden = false;
    }

    function clearUpsellError() {
      if (!errorElement) return;

      errorElement.textContent = '';
      errorElement.hidden = true;
    }

    function getCartErrorMessage(error) {
      if (!error) return 'The products could not be added to the cart.';
      if (typeof error.description === 'string') return error.description;
      if (typeof error.message === 'string') return error.message;
      return 'The products could not be added to the cart.';
    }

    toggle.addEventListener('click', function () {
      setUpsellActive(toggle.getAttribute('aria-pressed') !== 'true');
    });

    $(formContainer).on('variantChanged.pdpUpsell', function () {
      applyUpsellPrice();
    });

    purchaseForm.addEventListener('submit', function (event) {
      if (toggle.getAttribute('aria-pressed') !== 'true') return;

      if (window.theme && typeof window.theme.validateProductForm === 'function') {
        if (!window.theme.validateProductForm($(formContainer))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      clearUpsellError();

      var formData = new FormData(purchaseForm);
      var mainVariantId = formData.get('id');
      var mainQuantity = parseInt(formData.get('quantity') || '1', 10);

      if (!mainVariantId || !upsellVariantId) {
        showUpsellError('Please select a product option before adding to cart.');
        return;
      }

      var mainItem = {
        id: Number(mainVariantId),
        quantity: Number.isNaN(mainQuantity) ? 1 : Math.max(1, mainQuantity)
      };
      var properties = {};

      formData.forEach(function (value, key) {
        var propertyMatch = key.match(/^properties\[(.*)\]$/);

        if (propertyMatch && value !== '') {
          properties[propertyMatch[1]] = value;
        }
      });

      if (Object.keys(properties).length) {
        mainItem.properties = properties;
      }

      var sellingPlan = formData.get('selling_plan');
      if (sellingPlan) {
        mainItem.selling_plan = Number(sellingPlan);
      }

      var submitButton = event.submitter || purchaseForm.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.classList.add('btn--in-progress');
        submitButton.disabled = true;
      }

      var cartAddUrl = window.theme && window.theme.routes
        ? window.theme.routes.cart_add_url
        : '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            mainItem,
            {
              id: Number(upsellVariantId),
              quantity: 1
            }
          ],
          sections: 'cart-drawer'
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function (response) {
          if (window.theme && window.theme.settings && window.theme.settings.after_add_to_cart === 'no-js') {
            window.location.assign(window.theme.routes.cart_url);
            return;
          }

          if (window.theme && typeof window.theme.addedToCartHandler === 'function') {
            window.theme.addedToCartHandler.call($(purchaseForm), response);
          } else {
            document.documentElement.dispatchEvent(
              new CustomEvent('theme:cartchanged', {
                bubbles: true,
                cancelable: false,
                detail: { openDrawer: true }
              })
            );
          }
        })
        .catch(function (error) {
          showUpsellError(getCartErrorMessage(error));
        })
        .finally(function () {
          if (submitButton) {
            submitButton.classList.remove('btn--in-progress');
            submitButton.disabled = false;
          }
        });
    }, true);

    applyUpsellPrice();
  }

  function initPdpUpsellToggles(scope) {
    var toggles = scope.querySelectorAll('[data-pdp-upsell-toggle]');

    toggles.forEach(function (toggle) {
      initPdpUpsellToggle(toggle);
    });
  }

  initPdpUpsellToggles(document);

  document.addEventListener('shopify:section:load', function (event) {
    initPdpUpsellToggles(event.target);
  });
});
